import { inject, Injectable } from '@angular/core';

import { ENVIRONMENT } from './../../app.config';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  private env = inject(ENVIRONMENT, {
    optional: true
  }) || {};

  getValue(key: string, defaultValue?: any): any {
    return this.env[key] || defaultValue;
  }
}
